"use client";

import React from "react";

let cachedConfig: Record<string, string | undefined> | null = null;

export async function getRuntimeConfig() {
  if (cachedConfig) return cachedConfig;

  try {
    const response = await fetch("/api/config");
    cachedConfig = await response.json();
    return cachedConfig;
  } catch (error) {
    console.error("Failed to fetch runtime config:", error);
    return {};
  }
}

// Helper để lấy env variable với fallback
export function getEnv(key: string, fallback = ""): string {
  // Server-side: đọc trực tiếp từ process.env
  if (typeof window === "undefined") {
    return process.env[key] || fallback;
  }

  // Client-side: cần fetch config trước
  // Sử dụng cachedConfig nếu đã fetch
  return cachedConfig?.[key] || fallback;
}

// Hook để load config khi component mount
export function useRuntimeConfig() {
  const [config, setConfig] = React.useState<Record<string, string | undefined>>({});
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    getRuntimeConfig().then((cfg) => {
      setConfig(cfg);
      setLoading(false);
    });
  }, []);

  return { config, loading };
}

// Type-safe getters cho các env variables thường dùng (chỉ dùng server-side)
export const env = {
  get chatwootToken() {
    return getEnv("NEXT_PUBLIC_CHATWOOT_TOKEN");
  },
  get chatwootUrl() {
    return getEnv("NEXT_PUBLIC_CHATWOOT_URL");
  },
  get medusaBackendUrl() {
    return getEnv("NEXT_PUBLIC_MEDUSA_BACKEND_URL");
  },
  get medusaPublishableKey() {
    return getEnv("NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY");
  },
  get smartlookKey() {
    return getEnv("NEXT_PUBLIC_SMARTLOOK_KEY");
  },
  get facebookPixelId() {
    return getEnv("NEXT_PUBLIC_FACEBOOK_PIXEL_ID");
  },
  get appVersion() {
    return getEnv("NEXT_PUBLIC_APP_VERSION", "1.0.3");
  },
};
